import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AddCircleBlue, CustomDelete, EditWithIcon, MinLoader, NoItemsYet, TextRow } from 'components';
import { targetDetailsNotYet } from './constants';
import { httpRequestsOnSuccessActions, libraryActions } from 'store';
import { Colors, FindLoadItem, FindSuccessItem, Images, useModal } from 'utils';

export const TargetsDetails = ({ currentFolder, requestFoldersParams, isExpanded }) => {
    const [showCreatingInputs, toggleCreatingInputs] = useState(false);
    const [inputs, setInputs] = useState({});
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const ACTION_TYPE = inputs?.id ? 'EDIT_LIBRARY_TARGET' : 'CREATE_LIBRARY_TARGET';
    const loading = FindLoadItem(ACTION_TYPE);
    const success = FindSuccessItem(ACTION_TYPE);
    const { open } = useModal();

    useEffect(() => {
        if (success?.type) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(success));
            toggleCreatingInputs(false);
            setInputs({});
        }
    }, [success]);

    useEffect(() => {
        if (!isExpanded) {
            setInputs({});
            toggleCreatingInputs(false);
        }
    }, [isExpanded]);

    const handleAdd = () => {
        toggleCreatingInputs(true);
    };

    const handleChange = (e) => {
        setInputs((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
        if (error === e.target.name) {
            setError('');
        }
    };

    const resetCreation = () => {
        setError('');
        setInputs({});
        toggleCreatingInputs(false);
    };

    const handleAction = (type, item) => {
        if (type === 'delete') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this target? This action cannot be undone."
                    info="Delete Target"
                    handleDel={() => dispatch(libraryActions.deleteLibraryTarget(currentFolder?.id, item?.id, requestFoldersParams))}
                    actionType={'DELETE_LIBRARY_TARGET'}
                    innerText={'Delete'}
                />
            );
        } else {
            setError('');
            toggleCreatingInputs(true);
            setInputs(item);
        }
    };

    const handleSave = () => {
        if (inputs?.name) {
            const body = {
                ...inputs,
            };

            if (inputs?.id) {
                dispatch(libraryActions.editLibraryTarget(currentFolder?.id, inputs?.id, body, requestFoldersParams));
            } else {
                dispatch(libraryActions.createLibraryTarget(currentFolder?.id, body, requestFoldersParams));
            }
        } else {
            setError('name');
        }
    };

    return (
        <div className="targets-tab-details-wrapper">
            {!showCreatingInputs && !!currentFolder?.targets?.length && (
                <div className="flex-end" style={{ padding: '0 12px 8px' }}>
                    <AddCircleBlue type="button" text={'Add Target'} handleClick={() => handleAction('edit')} />
                </div>
            )}

            {currentFolder?.targets?.length ? (
                <div className="targets-tab-details-block">
                    {currentFolder?.targets?.map((target, index) => (
                        <div className="targets-tab-details-item-row" key={index}>
                            <div className="targets-tab-details-item-cell" style={{ width: 'fit-content' }}>
                                {index + 1}
                            </div>

                            <div className="targets-tab-details-item-cell" style={{ width: '25%' }}>
                                <TextRow name={target?.name} />
                            </div>

                            <div className="targets-tab-details-item-cell" style={{ width: '75%' }}>
                                <TextRow name={target?.description} />
                            </div>

                            <div className="targets-tab-details-item-cell" style={{ width: 'fit-content', minWidth: 'fit-content' }}>
                                <div className="flex-align-center" style={{ gap: 12 }}>
                                    <EditWithIcon
                                        id={'edit-form'}
                                        icon={Images.editAuth}
                                        type={'button'}
                                        handleClick={(e) => {
                                            e.stopPropagation();
                                            handleAction('edit', target);
                                        }}
                                    />

                                    <EditWithIcon
                                        id={'delete-form'}
                                        icon={Images.deleteTag}
                                        type={'button'}
                                        handleClick={(e) => {
                                            e.stopPropagation();
                                            handleAction('delete', target);
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                !showCreatingInputs && (
                    <NoItemsYet
                        image={targetDetailsNotYet.image}
                        btnText={targetDetailsNotYet.btnText}
                        text={targetDetailsNotYet.title}
                        subTitle={targetDetailsNotYet.subTitle}
                        handleAdd={handleAdd}
                        containerStyles={{
                            position: 'static',
                        }}
                        height="fit-content"
                    />
                )
            )}

            {showCreatingInputs && (
                <div className="create-target-wrapper">
                    <input
                        value={inputs?.name || ''}
                        onChange={handleChange}
                        placeholder={'Task Name'}
                        name="name"
                        type="text"
                        style={{ width: '25%', borderColor: error === 'name' ? '#FE7070' : '#E4E7EC' }}
                    />
                    <input
                        value={inputs?.description || ''}
                        onChange={handleChange}
                        placeholder={'Add Objective '}
                        name="description"
                        type="text"
                        style={{ width: '68%', borderColor: error === 'description' ? '#FE7070' : '#E4E7EC' }}
                    />

                    <div className="flex-align-center" style={{ gap: 4, width: 'fit-content' }}>
                        <button onClick={handleSave} className="add-target-btn">
                            {loading?.loadingType ? (
                                <MinLoader margin="3px 0 0" color={Colors.TextWhite} position="relative" />
                            ) : inputs?.id ? (
                                'Save'
                            ) : (
                                'Add'
                            )}
                        </button>
                        <button onClick={resetCreation} className="cancel-add-target-btn">
                            Cancel
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
